import { Component, Inject, OnInit, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FormGroup, FormBuilder } from '@angular/forms';
import { SaveService } from '../../../../services/save.service';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: "customeritem-filter",
    templateUrl: './customeritem-filter.component.html',
    styleUrls: ['../../../../style/form.component.less', 'customeritem-filter.component.less', '../../../../style/expand-collapse-panel.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CustomerItemFilterComponent implements OnInit {

    form!: FormGroup;
    @Output() outputFilter = new EventEmitter<CustomerFilter>();

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];

    customerNames: string[] = [];
    customerIds: string[] = [];

    constructor(
        private http: HttpClient
        , private fb: FormBuilder
        , @Inject('BASE_URL') private baseUrl: string
        , private saveService: SaveService
    ) {
    }

    ngOnInit() {
        this.saveService.addListener(this);
        this.createForm(); //it calls the method this.createForm()
    }

    createForm() {
        this.form = this.fb.group({
            CustomerId: [''],
            CustomerName: ['']
        });
    }

    onFilter() {
        if (this.form)
            this.outputFilter.emit(this.form.value as CustomerFilter)
    }

    changeTypeButton() {
        if (this.form)
            return !this.form.value.CustomerId && !this.form.value.CustomerName
        return null;
    }
}